var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1743495975903,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5407,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M768 947.2H256a102.4 102.4 0 0 1-102.4-102.4v-358.4a102.4 102.4 0 0 1 102.4-102.4v-51.2a256 256 0 0 1 506.88-51.2h-106.496A153.6 153.6 0 0 0 358.4 332.8v51.2h409.6a102.4 102.4 0 0 1 102.4 102.4v358.4a102.4 102.4 0 0 1-102.4 102.4z m0-460.8H256v358.4h512z m-256 51.2a102.4 102.4 0 0 1 102.4 102.4 102.4 102.4 0 0 1-51.2 88.064v65.536H460.8v-65.536a102.4 102.4 0 0 1-51.2-88.064 102.4 102.4 0 0 1 102.4-102.4z",
    fill: "#2c2c2c",
    "p-id": 5408
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/修改密码.376019a1fdc2207015d616af4e8b8947.svg";
export { ForwardRef as ReactComponent };